import React from 'react';
import TransportMode from './TransportMode';
import RouteAutosuggest from './RouteAutosuggest';

const bem = 'tt-route-search';
export default class RouteSearchComponent extends React.Component {
  render() {
    return (
      <div className={bem}>
        <div className={`${bem}__tranport-mode`}><TransportMode /></div>
        <div className={`${bem}__autosuggest`}><RouteAutosuggest storageKey="recentTimetables" /></div>
      </div>
    );
  }
}
